import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DeliveryIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M16.875 6H1.125V16.5H2.33033C2.38274 16.172 2.48348 15.8602 2.625 15.5721C3.16232 14.4779 4.28763 13.7249 5.58884 13.7249C7.23276 13.7249 8.59593 14.9269 8.84735 16.5H13.8411C14.0809 14.9991 15.3328 13.836 16.875 13.7324C16.9492 13.7274 17.0241 13.7249 17.0996 13.7249C17.5517 13.7249 17.9826 13.8158 18.375 13.9804C19.4092 14.4141 20.1758 15.3596 20.3581 16.5H22.875V12L20.9464 8.25H18.375V12.375H16.875V6ZM5.58884 12.2249C4.46986 12.2249 3.44086 12.6074 2.625 13.2489V7.5H15.375V12.5441C14.2128 12.9916 13.2694 13.8777 12.7467 15H9.94168C9.17799 13.3608 7.51699 12.2249 5.58884 12.2249ZM7.16371 17.0247C7.16371 17.8946 6.45855 18.5997 5.58869 18.5997C4.71883 18.5997 4.01367 17.8946 4.01367 17.0247C4.01367 16.1549 4.71883 15.4497 5.58869 15.4497C6.45855 15.4497 7.16371 16.1549 7.16371 17.0247ZM18.6745 17.0247C18.6745 17.8946 17.9693 18.5997 17.0994 18.5997C16.2296 18.5997 15.5244 17.8946 15.5244 17.0247C15.5244 16.1549 16.2296 15.4497 17.0994 15.4497C17.9693 15.4497 18.6745 16.1549 18.6745 17.0247Z"
      />
    </SvgIcon>
  );
});
